<template>
  <div>
    <b-form>
      <b-row class="mt-4">
        <b-col xl="3" lg="3" sm="3">
          <p class="mt-3">
            <span class="h3">Carrier</span>
          </p>
        </b-col>
        <b-col xl="9" lg="9" sm="9">
          <b-form-group label-for="input-1">
            <b-form-select id="eprl" :state="carrierStatus" v-model="shortCodeForm.carrier" :options="carrierlist"></b-form-select>
            <b-form-invalid-feedback :state="carrierStatus">
              Please select a valid Carrier.
            </b-form-invalid-feedback>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col xl="3" lg="3" sm="3">
          <p class="mt-3">
            <span class="h3">Dialed</span>
          </p>
        </b-col>
        <b-col xl="9" lg="9" sm="9">
          <b-form-group
              label-for="input-1"
          >
            <b-form-input
                id="input-1"
                :state="dialedStatus"
                v-model="shortCodeForm.dialed"
            ></b-form-input>
            <b-form-invalid-feedback :state="dialedStatus">
              Please enter a valid dialed
            </b-form-invalid-feedback>
          </b-form-group>
        </b-col>
      </b-row>
      
      <hr>
      <div class="mt-3 d-flex justify-content-between">
        <base-button type="white" title="Close"  v-on:click="modalClose()">
          Close
        </base-button>
        <base-button v-if="!update" type="primary" title="Save"  v-on:click="saveSubmit" :loading="submitLoading">
            Save
        </base-button>
        <base-button v-if="update" type="primary" title="Save"  v-on:click="saveUpdateSubmit" :loading="submitLoading">
            Save
        </base-button>
      </div>
    </b-form>
  </div>
</template>

<script>
import {VueTelInput} from 'vue-tel-input';
import 'vue-tel-input/dist/vue-tel-input.css';
// import handleResponse from "../../../../common/directive/handlResponse";
import productManagementService from "../../../../common/api-services/product-management-service";

export default {
  name: "Short-Codes-Form",
  props: [
    'update'
  ],
  components: {
    VueTelInput
  },
  computed: {
    carrierStatus() {
      return this.selected_carrier != "";
    },
    dialedStatus() {
      return this.shortCodeForm.dialed != "";
    },
  },
  data() {
    return {
      shortCodeForm: {
        carrier: "",
        dialed: "",
        short_code: "",
        olddialed: "",
      },
      // selected_carrier: [], 
      submitLoading: false,
      carrierlist: [],
    }
  },
  mounted() {
    this.getShortcodeCarrierList();
    this.$root.$on("ChangeShortCodeOldData", res => {
      console.log(res);
      this.shortCodeForm.carrier = res.carrier_code;
      this.shortCodeForm.olddialed = res.dialed;
      this.shortCodeForm.dialed = res.dialed;
      // this.shortCodeForm.short_code = res.short_code;
    });
  },
  methods: {

    modalClose() {
      this.$bvModal.hide('add-short-codes')
      this.$bvModal.hide('edit-short-codes')
    },

    async saveSubmit() {

      if (
          this.shortCodeForm.carrier != '' && 
          this.shortCodeForm.dialed != ''
        ) {
        this.submitLoading = true;

        await productManagementService.addShortCodes(this.shortCodeForm)
        .then((res) => {
          // console.log(res)
          this.$toast.success(res);
        })
        .catch((err) => {
          console.log(err)
          this.$toast.error(err);
        })

        this.modalClose();
        this.$root.$emit('getShortCodeFunc')
      } else {
        this.$root.$emit('danger', 'Please input valid data');
      }
    },

    async saveUpdateSubmit() {

      if (
          this.shortCodeForm.carrier != '' && 
          this.shortCodeForm.dialed != ''
        ) {
        this.submitLoading = true;

        await productManagementService.updateShortCodes(this.shortCodeForm)
        .then((res) => {
          // console.log(res)
          this.$toast.success(res);
        })
        .catch((err) => {
          console.log(err)
          this.$toast.error(err);
        })

        this.modalClose();
        this.$root.$emit('getShortCodeFunc')
      } else {
        this.$root.$emit('danger', 'Please input valid data');
      }
    },
    
    async getShortcodeCarrierList(){
      const carrier = await productManagementService.getShortcodeCarrierList();
      const uniqueCarrierSet = new Set();

      carrier.forEach((item) => {
        if (!uniqueCarrierSet.has(item.carrier)) {
          uniqueCarrierSet.add(item.carrier);
          this.carrierlist.push({
            value: item.carrier_code,
            text: item.carrier,
          });
        }
      });

      this.carrierlist.sort((a, b) => {
        return a.text.localeCompare(b.text);
      });
    },

  }
}
</script>
